/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BalanceUnitStatementEntryDebit } from './BalanceUnitStatementEntryDebit';
import {
    BalanceUnitStatementEntryDebitFromJSON,
    BalanceUnitStatementEntryDebitFromJSONTyped,
    BalanceUnitStatementEntryDebitToJSON,
    BalanceUnitStatementEntryDebitToJSONTyped,
} from './BalanceUnitStatementEntryDebit';
import type { PaymentType } from './PaymentType';
import {
    PaymentTypeFromJSON,
    PaymentTypeFromJSONTyped,
    PaymentTypeToJSON,
    PaymentTypeToJSONTyped,
} from './PaymentType';
import type { Gender } from './Gender';
import {
    GenderFromJSON,
    GenderFromJSONTyped,
    GenderToJSON,
    GenderToJSONTyped,
} from './Gender';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface CreateEmployeeRequest
 */
export interface CreateEmployeeRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeRequest
     */
    role: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeRequest
     */
    cellPhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeRequest
     */
    homePhone?: string | null;
    /**
     * 
     * @type {Gender}
     * @memberof CreateEmployeeRequest
     */
    gender?: Gender | null;
    /**
     * 
     * @type {any}
     * @memberof CreateEmployeeRequest
     */
    dateOfBirth?: any | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeRequest
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeRequest
     */
    zip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeRequest
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeRequest
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeRequest
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeRequest
     */
    payrollId?: string | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof CreateEmployeeRequest
     */
    payRate?: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {PaymentType}
     * @memberof CreateEmployeeRequest
     */
    paymentType?: PaymentType | null;
    /**
     * 
     * @type {Array<ApiUserTasksGetPageParameter>}
     * @memberof CreateEmployeeRequest
     */
    workLocationIds?: Array<ApiUserTasksGetPageParameter> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateEmployeeRequest
     */
    roles?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeRequest
     */
    engagement?: string | null;
}



/**
 * Check if a given object implements the CreateEmployeeRequest interface.
 */
export function instanceOfCreateEmployeeRequest(value: object): value is CreateEmployeeRequest {
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function CreateEmployeeRequestFromJSON(json: any): CreateEmployeeRequest {
    return CreateEmployeeRequestFromJSONTyped(json, false);
}

export function CreateEmployeeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEmployeeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'role': json['role'],
        'email': json['email'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'cellPhone': json['cellPhone'] == null ? undefined : json['cellPhone'],
        'homePhone': json['homePhone'] == null ? undefined : json['homePhone'],
        'gender': json['gender'] == null ? undefined : GenderFromJSON(json['gender']),
        'dateOfBirth': json['dateOfBirth'] == null ? undefined : json['dateOfBirth'],
        'address': json['address'] == null ? undefined : json['address'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'country': json['country'] == null ? undefined : json['country'],
        'payrollId': json['payrollId'] == null ? undefined : json['payrollId'],
        'payRate': json['payRate'] == null ? undefined : BalanceUnitStatementEntryDebitFromJSON(json['payRate']),
        'paymentType': json['paymentType'] == null ? undefined : PaymentTypeFromJSON(json['paymentType']),
        'workLocationIds': json['workLocationIds'] == null ? undefined : ((json['workLocationIds'] as Array<any>).map(ApiUserTasksGetPageParameterFromJSON)),
        'roles': json['roles'] == null ? undefined : json['roles'],
        'engagement': json['engagement'] == null ? undefined : json['engagement'],
    };
}

export function CreateEmployeeRequestToJSON(json: any): CreateEmployeeRequest {
    return CreateEmployeeRequestToJSONTyped(json, false);
}

export function CreateEmployeeRequestToJSONTyped(value?: CreateEmployeeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'role': value['role'],
        'email': value['email'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'cellPhone': value['cellPhone'],
        'homePhone': value['homePhone'],
        'gender': GenderToJSON(value['gender']),
        'dateOfBirth': value['dateOfBirth'],
        'address': value['address'],
        'zip': value['zip'],
        'city': value['city'],
        'state': value['state'],
        'country': value['country'],
        'payrollId': value['payrollId'],
        'payRate': BalanceUnitStatementEntryDebitToJSON(value['payRate']),
        'paymentType': PaymentTypeToJSON(value['paymentType']),
        'workLocationIds': value['workLocationIds'] == null ? undefined : ((value['workLocationIds'] as Array<any>).map(ApiUserTasksGetPageParameterToJSON)),
        'roles': value['roles'],
        'engagement': value['engagement'],
    };
}

